/**
 * i18next setup — PT-BR canônico, EN fallback.
 *
 * Cuidari rebrand prep: scaffolding pra extração progressiva de strings.
 * Convenção: chaves em camelCase, namespace por feature.
 * Detector de linguagem do browser, mas default = 'pt-BR'.
 */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import commonPtBR from './locales/pt-BR/common.json'
import authPtBR from './locales/pt-BR/auth.json'
import onboardingAdminPtBR from './locales/pt-BR/onboarding-admin.json'
import adminPtBR from './locales/pt-BR/admin.json'
import peithoPtBR from './locales/pt-BR/peitho.json'
import consolePtBR from './locales/pt-BR/console.json'
import spotlightPtBR from './locales/pt-BR/spotlight.json'

import commonEn from './locales/en/common.json'
import authEn from './locales/en/auth.json'
import onboardingAdminEn from './locales/en/onboarding-admin.json'
import adminEn from './locales/en/admin.json'
import peithoEn from './locales/en/peitho.json'
import consoleEn from './locales/en/console.json'
import spotlightEn from './locales/en/spotlight.json'

export const defaultNS = 'common'
// T10 Frente B.1 adds the `spotlight` namespace; keys live under
// `<area>.<element>.{title,body}` per spec §11.3.
// T10 Frente E.1 adds the `onboardingAdmin` namespace for the
// `/odysseus/onboarding` admin surface (kept separate from the
// consumer-facing `onboarding` namespace so each ships only the copy
// it needs).
export const namespaces = [
  'common',
  'auth',
  'onboardingAdmin',
  'admin',
  'peitho',
  'console',
  'spotlight',
] as const
export type Namespace = (typeof namespaces)[number]

export const resources = {
  'pt-BR': {
    common: commonPtBR,
    auth: authPtBR,
    onboardingAdmin: onboardingAdminPtBR,
    admin: adminPtBR,
    peitho: peithoPtBR,
    console: consolePtBR,
    spotlight: spotlightPtBR,
  },
  en: {
    common: commonEn,
    auth: authEn,
    onboardingAdmin: onboardingAdminEn,
    admin: adminEn,
    peitho: peithoEn,
    console: consoleEn,
    spotlight: spotlightEn,
  },
} as const

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR',
    fallbackLng: 'en',
    defaultNS,
    ns: namespaces as unknown as string[],
    supportedLngs: ['pt-BR', 'en'],
    interpolation: {
      escapeValue: false, // React já escapa
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ariadne.lang',
    },
    returnNull: false,
  })

export default i18n
